import React from "react";

import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";

import Color from "color";

const useStyles = makeStyles({
    span: {
        fontSize: "13px",
    },
    ButtonCriar: {
        borderColor: (props) => props.border,
        borderRadius: "20px",
        height: (props) => props.height,
        minWidth: (props) => props.minWidth,
        padding: "7px 12px 6px 12px",
        background: (props) => props.color,
        color: (props) => (props.border ? props.border : "white"),

        "&:hover": {
            backgroundColor: (props) => Color(props.color).fade(0.25).string(),
        },
    },
});

function ButtonLarge({
    icon,
    loading,
    onClick,
    minWidth,
    height,
    texto,
    border,
    color,
    className,
    ...props
}) {
    const classes = useStyles({ border, color, minWidth, height });
    return (
        <>
            <Button
                size="large"
                disabled={loading}
                color="primary"
                className={`${classes.ButtonCriar} ${className}`}
                onClick={onClick}
                aria-label="Add"
                variant={border ? "outlined" : "extended"}
            >
                {/* <FontAwesomeIcon icon={icon} className="mr-2" /> */}
                <span className={classes.span}> {texto} </span>
            </Button>
        </>
    );
}

export default ButtonLarge;
